import DxmlTextPart from "../DxmlTextPart"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import * as Constants from "../../../../../utils/constants";

export default function DxmlTextChoice({ editorTextChoice }) {
    const { getKeyById } = useEditorFile();
    const elementsToShow = editorTextChoice.Items.filter(x => x.Type === Constants.editorType.textPart);

    const elementClassnNames = (element, index) => {
        const spaceY = "tw-mb-3";
        if (editorTextChoice.IsRadioGroupMode)
            return "";
        if (index === (elementsToShow.length - 1))
            return "";
        return spaceY;
    }

    return (
        <>
            {
                elementsToShow.map((editorTextPart, index) => (
                    <div key={getKeyById(editorTextPart)} className={elementClassnNames(editorTextPart, index)}>
                        <DxmlTextPart editorTextPart={editorTextPart} editorTextChoice={editorTextChoice} />
                    </div>
                ))
            }
        </>
    )
}